export default Object.freeze({
  RpExpiredDocuments: 67,
});
